module.exports = __webpack_public_path__ + "img/seagull_instruction.0c1d851b.jpg";